import { css } from '@emotion/css';
import React from 'react';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Icon } from 'src/assets/images/fortune/ic-nookpoint.svg';
import { usePrefersReducedMotion } from 'src/components/shared/usePrefersReducedMotion';
import { formatNumber } from 'src/lib/format-number';

export interface OwnedPointProps {
  end: number;
  start?: number;
}

export const OwnedPoint: React.FC<OwnedPointProps> = React.memo(props => {
  const { t, i18n } = useTranslation('fortune');
  const prefersReducedMotion = usePrefersReducedMotion();

  const start = props.start ?? null;
  const end = props.end;

  return (
    <div
      className={css`
        color: #4d3906;
        height: 60px;
        .label {
          font-size: 12px;
          text-align: center;
        }
      `}
    >
      <div className="label">{t('owned_point')}</div>

      <div
        className={css`
          display: flex;
          justify-content: center;
          align-items: center;

          .value {
            font-size: 32px;
            line-height: 1.2;
            margin: 0 0 0 2px;
          }
        `}
      >
        <Icon width={36} height={36} />
        <span className="value">
          {start !== null && !prefersReducedMotion ? (
            <CountUp
              start={start}
              end={end}
              preserveValue={true}
              delay={0.5}
              duration={0.5}
              useEasing={false}
              formattingFn={n => formatNumber(n, i18n.language)}
            />
          ) : (
            formatNumber(end, i18n.language)
          )}
        </span>
      </div>
    </div>
  );
});
